import { render, staticRenderFns } from "./UserPagination.vue?vue&type=template&id=08d7ba3e&scoped=true"
import script from "./UserPagination.vue?vue&type=script&lang=js"
export * from "./UserPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7ba3e",
  null
  
)

export default component.exports